
const digest = '7352c7a378f3ad09e65f34c0458d431d5a3d8d4f6dbfbff3b0b935693b502fec';
const classes = {"wrapper":"_wrapper_1ph98_1","header":"_header_1ph98_10","title":"_title_1ph98_15","red":"_red_1ph98_22","yellow":"_yellow_1ph98_25","green":"_green_1ph98_28","icons":"_icons_1ph98_31","content":"_content_1ph98_40"};
const css = `._wrapper_1ph98_1 {
  font-family: "Rubik", sans-serif;
  display: flex;
  flex-direction: column;
  padding: 12px;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  gap: 5px;
}
._wrapper_1ph98_1 ._header_1ph98_10 {
  display: flex;
  align-items: center;
  gap: 12px;
}
._wrapper_1ph98_1 ._header_1ph98_10 ._title_1ph98_15 {
  font-weight: 500;
  color: #1665d8;
  text-decoration: underline;
  font-size: 14px;
  flex: 1;
}
._wrapper_1ph98_1 ._header_1ph98_10 ._title_1ph98_15._red_1ph98_22 {
  color: #D81616;
}
._wrapper_1ph98_1 ._header_1ph98_10 ._title_1ph98_15._yellow_1ph98_25 {
  color: #CDA50D;
}
._wrapper_1ph98_1 ._header_1ph98_10 ._title_1ph98_15._green_1ph98_28 {
  color: #619612;
}
._wrapper_1ph98_1 ._header_1ph98_10 ._icons_1ph98_31 {
  display: flex;
  align-items: center;
  gap: 5px;
}
._wrapper_1ph98_1 ._header_1ph98_10 ._icons_1ph98_31 img {
  height: 18px;
  width: 18px;
}
._wrapper_1ph98_1 ._content_1ph98_40 {
  color: #1665d8;
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  font-weight: 500;
  font-size: 12px;
}
._wrapper_1ph98_1 ._content_1ph98_40 span {
  font-weight: 300;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  